
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 45 45"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.439 32.632A18.426 18.426 0 0118.5 37C8.283 37 0 28.717 0 18.5S8.283 0 18.5 0 37 8.283 37 18.5c0 4.55-1.643 8.717-4.368 11.939l.016.015 11.898 11.898a1.551 1.551 0 11-2.194 2.194L30.454 32.648a1.583 1.583 0 01-.015-.016zM18.5 33.42c8.24 0 14.92-6.68 14.92-14.919 0-8.24-6.68-14.92-14.92-14.92S3.58 10.26 3.58 18.5s6.68 14.92 14.92 14.92z"}})])
          )
        }
      }
    